import { DocumentReference, WriteBatch } from '@firebase/firestore-types';
import { firestore } from '../firebase';

const getRefsFromMobile = async (mobile: string) => {
  try {
    const query = await firestore
      .collection('users')
      .where('mobile', '==', mobile)
      .get();
    const refs: DocumentReference[] = [];

    query.forEach(doc => {
      console.log(doc.data());
      refs.push(doc.ref);
    });

    return refs;
  } catch (error) {
    console.error(error);

    return [];
  }
};

const deleteCheckIns = async (
  userRef: DocumentReference,
  batch: WriteBatch,
) => {
  try {
    const query = await firestore
      .collection('checkIns')
      .where('userId', '==', userRef.id)
      .get();

    query.forEach(doc => batch.delete(doc.ref));

    return batch;
  } catch (error) {
    console.error(error);

    return batch;
  }
};

export default async ({
  mobile,
  userId,
}: {
  mobile?: string;
  userId?: string;
}) => {
  let returnMessage = 'no user found';

  console.log(mobile, userId);

  try {
    const userRefs = userId
      ? [firestore.collection('users').doc(userId)]
      : mobile
        ? await getRefsFromMobile(mobile)
        : [];

    if (userRefs.length === 0) {
      return returnMessage;
    } else {
      const batch = firestore.batch();
      const checkInsDeletes: Array<Promise<WriteBatch>> = [];

      userRefs.forEach(userRef => {
        checkInsDeletes.push(deleteCheckIns(userRef, batch));
        batch.delete(userRef);
      });

      await Promise.all(checkInsDeletes);

      await batch.commit();

      returnMessage = 'user and checkIns have been deleted';
    }
  } catch (error) {
    returnMessage = error;
  }

  return returnMessage;
};



// WEBPACK FOOTER //
// ./src/adminFunctions/deleteUser.ts